import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import { cartClear } from '../App/actions'
import { Bg, MainLayout, ContentLayout } from '../CartPage/styledComponents'
import {
  PageWrapper,
  PageHeader, PageIconBox, PageIconImg, PageTitle, PageSubtitle,
  StatusPage, GradientTitle, StatusSubtitle, StatusBody, StatusBtn, Spinner,
} from '../Cart/styledComponents'
import shoppingBagIcon from '../../images/icon-shopping-bag.png'

const apiBase = process.env.REACT_APP_TGDAPI_SERVER || ''

const CartSuccess = () => {
  const history     = useHistory()
  const stripeSessionId = new URLSearchParams(useLocation().search).get('session_id')
  const dispatch    = useDispatch()
  const clearCart   = () => dispatch(cartClear())
  const agencyToken = useSelector(state => state.toJS().global.agencytoken) || ''

  const [status, setStatus] = useState('pending') // 'pending' | 'completed' | 'failed' | 'error'

  useEffect(() => {
    const token  = agencyToken
    let active   = true
    let attempts = 0

    const poll = async () => {
      if (!active) return
      if (attempts >= 20) { setStatus('error'); return }
      attempts++

      try {
        const resp = await fetch(`${apiBase}/order`, {
          headers: { 'Authorization': `Bearer ${token}` },
        })
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)

        const data   = await resp.json()
        const list   = Array.isArray(data) ? data : (data.orders || [])
        // Commande du Checkout payé ; à défaut (ancien lien sans session_id), la plus récente
        const order  = stripeSessionId
          ? list.find(o => o.stripeSessionId === stripeSessionId)
          : [...list].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]

        if (order?.status === 'completed') {
          clearCart()
          setStatus('completed')
        } else if (order?.status === 'failed') {
          setStatus('failed')
        } else {
          setTimeout(poll, 3000)
        }
      } catch {
        setTimeout(poll, 3000)
      }
    }

    poll()
    return () => { active = false }
  }, [])

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        <ContentLayout>
          <PageWrapper>
            <PageHeader>
              <PageIconBox>
                <PageIconImg src={shoppingBagIcon} alt='' />
              </PageIconBox>
              <div>
                <PageTitle>Mon panier</PageTitle>
                <PageSubtitle>Repartez tout·e équipé·e</PageSubtitle>
              </div>
            </PageHeader>

            {status === 'pending' && (
              <StatusPage>
                <Spinner />
                <GradientTitle>Confirmation en cours…</GradientTitle>
                <StatusSubtitle>Paiement reçu, nous vérifions votre commande.</StatusSubtitle>
                <StatusBody>
                  Merci de ne pas fermer cette page. La confirmation arrive dans quelques instants.
                </StatusBody>
              </StatusPage>
            )}

            {status === 'completed' && (
              <StatusPage>
                <GradientTitle>Félicitations !</GradientTitle>
                <StatusSubtitle>Votre paiement a été effectué avec succès.</StatusSubtitle>
                <StatusBody>
                  Vous allez recevoir une confirmation par mail avec les détails de la facture.
                  Vous pouvez aussi la retrouver dans l'historique de vos achats.
                </StatusBody>
                <StatusBtn onClick={() => history.push('/sessions')}>
                  Voir mes formations
                </StatusBtn>
              </StatusPage>
            )}

            {status === 'failed' && (
              <StatusPage>
                <GradientTitle>Paiement refusé.</GradientTitle>
                <StatusSubtitle>Votre paiement n'a pas abouti.</StatusSubtitle>
                <StatusBody>
                  Le paiement a été refusé. Vous pouvez réessayer avec une autre carte
                  ou contacter votre conseiller bancaire.
                </StatusBody>
                <StatusBtn onClick={() => history.push('/cart')}>
                  Réessayer
                </StatusBtn>
              </StatusPage>
            )}

            {status === 'error' && (
              <StatusPage>
                <GradientTitle>Houston ! Nous avons un problème.</GradientTitle>
                <StatusSubtitle>Impossible de confirmer votre paiement pour l'instant.</StatusSubtitle>
                <StatusBody>
                  Si vous avez été débité, contactez-nous — votre commande sera traitée manuellement.
                </StatusBody>
                <StatusBtn onClick={() => history.push('/cart')}>
                  Retourner au panier
                </StatusBtn>
              </StatusPage>
            )}

          </PageWrapper>
        </ContentLayout>
      </MainLayout>
    </Bg>
  )
}

export default CartSuccess
